import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from '../../app.service';

@Component({
  selector: 'app-mother',
  templateUrl: './mother.component.html',
  styleUrls: ['./mother.component.scss']
})
export class MotherEligibilityComponent implements OnInit {

  deceased = this.appState.get();
  	all_conditions: boolean = false;
	
	constructor(public appState: AppService, public router: Router) {
		this.appState = this.appState;
	}

	

	// Eligibility Check
	eligibilityCheck(deceased: any = false) {
		if( deceased ) {
			this.deceased = deceased;
		}
		
	    if( this.deceased['mother'].alive == "true" ) {
	      var this_mother = this.deceased['mother'];

	      // If All empty Continue without Checking
	      if( this_mother.muslim == "" && this_mother.legitimate == "" && this_mother.deceased_killer == "" && (this_mother.free_person == "true" || this_mother.free_person == "") ) {
	        this.deceased['mother'].eligibility = "";
				return undefined;

	      } else {
	        // Otherwise Check
	        if( this_mother.muslim == "true" && this_mother.legitimate == "true" && this_mother.deceased_killer == "true" && this_mother.free_person == "true" ) {
	          
	          this.deceased['mother'].eligibility = "true";
	          this.all_conditions = true;
	        
	        } else {
	          
	          this.deceased['mother'].eligibility = "false";
	          if( this.all_conditions == false )  {
	            this.all_conditions = false;
	          }

	        }
	      }

	      return this.all_conditions;
	    }
	}


	// Back Button
	back(event) {
		this.router.navigate(['level1-inheritors']);		
		event.preventDefault();
	}

	// Next Button is clicked
	next(event) {
		// Eligibility Test
		this.eligibilityCheck();

		// Save
		this.appState.set(this.deceased);

		// Redirect to Results Page
		this.router.navigate(['level1-inheritors']);

		event.preventDefault();

	}

  ngOnInit() {
  }

}
